import { render } from "./VisitorAlertCard.vue?vue&type=template&id=379dee1b"
import script from "./VisitorAlertCard.vue?vue&type=script&lang=js"
export * from "./VisitorAlertCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__